(ns ui.view.card.fees.sub
  (:require
   [ui.util :as uu]
   [re-frame.core :as rf]
   [ui.view.card.sub :as common-sub]
   [ui.state.session.sub :as session-sub]
   [common.schema.registry :as registry]
   [common.schema.data-types :as data-types]
   [common.util :as cu]
   [ui.view.card.entity-list.util :as entity-list-util]))

(defn fee? [entity]
  (= (:entity/type entity) :entity.type/fee))

(defn resolve-row-data
  [{:keys [entity fields entities-by-id tenant tenant-schema]}]
  (let [base-data entity
        data (->> fields
                  (mapv
                   (fn [field]
                     (let [field-schema (registry/get-field-schema tenant-schema field)
                           data-type (:field/data-type field-schema)
                           numeric? (-> data-type
                                        data-types/numeric-data-types
                                        boolean)
                           currency? (= data-type :data.type/currency-value)
                           value (get entity field)
                           materialized-value (uu/field-value->materialized-value
                                               {:field field
                                                :value value
                                                :tenant tenant
                                                :tenant-schema tenant-schema
                                                :id->entity entities-by-id
                                                :entity entity
                                                :show-currency? true})

                           ;; TODO: What other fields need to be converted?
                           value (if (and value currency?)
                                   (uu/bigdec->float value)
                                   value)

                           value-map {:value value
                                      :materialized-value materialized-value
                                      :numeric? numeric?}]
                       [field value-map])))
                  (into {}))]
    (merge base-data data)))

(rf/reg-sub
 ::fees
 (fn [[_ ctx]]
   [(rf/subscribe [::common-sub/entities ctx])])
 (fn [[card-entities-by-id] [_ ctx]]
   (let [primary-entity-id (:entity-id ctx)
         fees (->> card-entities-by-id
                   vals
                   (filterv (fn [entity]
                              (and (fee? entity)
                                   (some #{primary-entity-id}
                                         (:common/related-entities entity))))))]
     fees)))

(rf/reg-sub
 ::fees-count
 (fn [[_ ctx]]
   [(rf/subscribe [::fees ctx])])
 (fn [[fees]]
   (count fees)))

(rf/reg-sub
 ::table-data
 (fn [[_ ctx]]
   [(rf/subscribe [::fees ctx])
    (rf/subscribe [::common-sub/entities ctx])
    (rf/subscribe [::session-sub/entities])
    (rf/subscribe [::session-sub/tenant])
    (rf/subscribe [::session-sub/tenant-schema])])
 (fn [[fees
       card-entities-by-id
       global-entities-by-id
       tenant
       tenant-schema]
      [_ {:keys [card] :as _ctx}]]
   (let [all-entities-by-id (merge global-entities-by-id card-entities-by-id)
         column-fields (->> card
                            :card/config
                            :table
                            :columns
                            (mapv :field))]
     (entity-list-util/entities->table-row-data
      {:entities fees
       :column-fields column-fields
       :entities-by-id all-entities-by-id
       :tenant tenant
       :tenant-schema tenant-schema}))))

;; FIXME: field permissions?
(rf/reg-sub
 ::delete-fee-helper-text
 (fn [[_ ctx]]
   [(rf/subscribe [::common-sub/delete-confirmation-entity-id ctx])
    (rf/subscribe [::common-sub/entities ctx])
    (rf/subscribe [::session-sub/tenant])
    (rf/subscribe [::session-sub/tenant-schema])
    (rf/subscribe [::session-sub/entities])])
 (fn [[delete-confirmation-entity-id card-entities-by-id
       tenant tenant-schema global-entities-by-id]]
   (let [fee (get card-entities-by-id delete-confirmation-entity-id)
         get-materialized-value (fn [field]
                                  (uu/field-value->materialized-value
                                   {:field field
                                    :value (get fee field)
                                    :tenant tenant
                                    :tenant-schema tenant-schema
                                    :id->entity (merge global-entities-by-id
                                                       card-entities-by-id)
                                    :entity fee
                                    :show-currency? true}))
         status (get-materialized-value :fee/status)
         payer (get-materialized-value :fee/payer)
         amount (get-materialized-value :fee/cur-amount)
         date (get-materialized-value :fee/date-fee-date)

         show-part? (fn [materialized-value]
                      (not (cu/blank-value? materialized-value)))]
     ;; TODO: Add localization once confirmed with PO
     (str "You are about to delete a"
          (if (show-part? status)
            (str " " status " fee")
            " fee")
          (when (show-part? payer)
            (str " paid by " payer))
          (when (show-part? amount)
            (str " of " amount))
          (when (show-part? date)
            (str " on " date))
          ""))))

